import { render, staticRenderFns } from "./assetscomponent.vue?vue&type=template&id=335af524&"
import script from "./assetscomponent.vue?vue&type=script&lang=ts&"
export * from "./assetscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports